import { OTA_STATUS, OTA_ERROR_CODE, OTAUpdatePayload } from '../../../utils/otaTypes'

export type OTAViewState = { type: 'progress'; label: string; progress?: number } | { type: 'success'; label: string; action: 'reboot' | 'close' } | { type: 'error'; label: string; retryable: boolean } | { type: 'rebooting'; label: string } | { type: 'idle' }

export const mapOTADataToViewState = (payload: OTAUpdatePayload, polyglot: any): OTAViewState => {
    if (!payload) return { type: 'idle' }

    // 🔴 ERROR
    if (payload.type === 'error' && payload.data.code) {
        const code = payload.data.code as OTA_ERROR_CODE
        const retryable = ![OTA_ERROR_CODE.BUSY].includes(code)

        return {
            type: 'error',
            label: polyglot.t(`ota.error.${code}`),
            retryable
        }
    }

    // 🟡 PROGRESS
    if (payload.type === 'progress' && payload.data.state) {
        const state = payload.data.state as OTA_STATUS

        if (state === OTA_STATUS.DOWNLOADING) {
            return {
                type: 'progress',
                label: polyglot.t('ota.inProgress'),
                progress: payload.data.value
            }
        }

        if (state === OTA_STATUS.COMPLETE) {
            return {
                type: 'success',
                label: polyglot.t(`ota.status.${state}`),
                action: 'reboot'
            }
        }

        if (state === OTA_STATUS.UPDATED) {
            return {
                type: 'success',
                label: polyglot.t('ota.updatedSuccessful'),
                action: 'close'
            }
        }

        return {
            type: 'progress',
            label: polyglot.t(`ota.status.${state}`)
        }
    }

    return { type: 'idle' }
}
